function getFirstType(place) {
    return place.types && place.types.length && place.types[0];
}

function getTerm(place) {
    return place.fullName || (place.name && place.name.full);
}

/**
 * mapModel()
 * Convert the model, received from API into client-side model
 * @param {*} model
 */
export function mapModel(model) {
    if (!model.place) {
        return model;
    }
    const term = getTerm(model.place);
    return {
        uuid: model.place.uuid,
        term,
        type: getFirstType(model.place),
        ...(model.subSuggestions ? {subSuggestions: model.subSuggestions} : {}),
        ...(model.matchType ? {matchType: model.matchType} : {})
    };
}

/**
 * mapGoogleModel()
 * Convert the model, received from Google into client-side model
 * @param {*} model
 */
export function mapGoogleModel(model) {
    return {
        google: model,
        uuid: model.place_id,
        term: model.description,
        type: model.types[0],
        poweredByGoogle: true
    };
}
